export default {
  lang: 'th',
  file: {
    wangEditor: {
      插入: 'แทรก',
      默认: 'ดีฟอลท์',
      创建: 'สร้าง',
      修改: 'แก้ไข',
      如: 'เช่น',
      请输入正文: 'กรุณากรอกข้อความ',
      menus: {
        title: {
          标题: 'หัวข้อ',
          加粗: 'ตัวหนา',
          字号: 'ขนาด',
          字体: 'แบบตัวอักษร',
          斜体: 'ตัวเอียง',
          下划线: 'ตัวขีดเส้นใต้',
          删除线: 'ลบเส้น',
          缩进: 'ย่อหน้า',
          行高: 'ระยะห่างบรรทัด',
          文字颜色: 'สีตัวอักษร',
          背景色: 'สีพื้นหลัง',
          链接: 'ลิงก์',
          序列: 'ลำดับ',
          对齐: 'จัดตำแหน่ง',
          引用: 'อ้างอิง',
          表情: 'อีโมติคอน',
          图片: 'รูปภาพ',
          视频: 'วีดีโอ',
          表格: 'ตาราง',
          代码: 'โค้ด',
          分割线: 'เส้นแบ่งบรรทัด',
          恢复: 'ทำซ้ำ',
          撤销: 'ย้อนกลับ',
          全屏: 'เต็มจอ',
          代办事项: 'สิ่งที่ต้องทำ'
        },
        dropListMenu: {
          设置标题: 'ตั้งค่าหัวข้อ',
          背景颜色: 'สีพื้นหลังตัวอักษร',
          文字颜色: 'สีตัวอักษร',
          设置字号: 'ตั้งค่าขนาดตัวอักษร',
          设置字体: 'ตั้งค่าแบบตัวอักษร',
          设置缩进: 'ตั้งค่าย่อหน้า',
          对齐方式: 'จัดตำแหน่ง',
          设置行高: 'ตั้งค่าระยะห่างบรรทัด',
          序列: 'ลำดับ',
          head: {
            正文: 'ตัวอักษร'
          },
          indent: {
            增加缩进: 'เพิ่มย่อหน้า',
            减少缩进: 'ลดย่อหน้า'
          },
          justify: {
            靠左: 'ชิดซ้าย',
            居中: 'กลาง',
            靠右: 'ชิดขวา'
          },
          list: {
            无序列表: 'ไม่เรียงลำดับ',
            有序列表: 'เรียงลำดับ'
          }
        },
        panelMenus: {
          emoticon: {
            默认: 'Default',
            新浪: 'sina',
            emoji: 'emoji',
            手势: 'ท่าทาง'
          },
          image: {
            图片链接: 'ลิงก์รูปภาพ',
            上传图片: 'อัปโหลดรูปภาพ',
            网络图片: 'รูปภาพอินเตอร์เน็ต'
          },
          link: {
            链接: 'ลิงก์',
            链接文字: 'ลิงก์ตัวอักษร',
            删除链接: 'ลบลิงก์',
            查看链接: 'ดูลิงก์'
          },
          video: {
            插入视频: 'แทรกวีดีโอ'
          },
          table: {
            行: 'แถว',
            列: 'คอลัมภ์',
            的: 'ของ',
            表格: 'ตาราง',
            添加行: 'เพิ่มแถว',
            删除行: 'ลบแถว',
            添加列: 'เพิ่มคอลัมภ์',
            删除列: 'ลบคอลัมภ์',
            设置表头: 'ตั้งค่าหัวข้อ',
            取消表头: 'ยกเลิกตัวข้อ',
            插入表格: 'แทรกตาราง',
            删除表格: 'ลบตาราง'
          },
          code: {
            删除代码: 'ลบโค้ด',
            修改代码: 'แก้ไขโค้ด',
            插入代码: 'แทรกโค้ด'
          }
        }
      },
      validate: {
        张图片: 'รูปภาพ',
        大于: 'มากกว่า',
        图片链接: 'ลิงก์รูปภาพ',
        不是图片: 'ไม่ใช่รูปภาพ',
        返回结果: 'ย้อนกลับ',
        上传图片超时: 'เกินเวลาอัปโหลดรูปภาพ',
        上传图片错误: 'อัปโหลดรูปภาพผิดพลาด',
        上传图片失败: 'อัปโหลดรูปภาพไม่สำเร็จ',
        插入图片错误: 'แทรกรูปภาพผิดพลาด',
        一次最多上传: 'อัปโหลดมากที่สุดหนึ่งครั้ง',
        下载链接失败: 'ดาวน์โหลดลิงก์ล้มเหลว',
        图片验证未通过: 'การยืนยันรูปภาพล้มเหลว',
        服务器返回状态: 'เซิร์ฟเวอร์สถานะย้อนกลับ',
        上传图片返回结果错误: 'อัปโหลดรูปภาพไม่ถูกต้อง',
        请替换为支持的图片类型: 'กรุณาอัปโหลดประเภทรูปภาพที่สนับสนุน ',
        您插入的网络图片无法识别: 'ไม่สามารถอ่านค่ารูปภาพที่แทรกได้',
        您刚才插入的图片链接未通过编辑器校验: 'ลิงก์รูปภาพที่แทรกไม่ผ่านการตรวจสอบ'
      }
    }
  }
};